import DOMPurify from 'dompurify'
import { useMemo } from 'react'
import './HtmlTextDisplay.scss'

interface HtmlTextDisplayProps {
  value: string | undefined
  className?: string
}

export function HtmlTextDisplay({ value, className }: HtmlTextDisplayProps) {
  const purifiedMessage = useMemo(
    () => DOMPurify.sanitize(value ?? ''),
    [value]
  )

  return (
    <div
      className={`html-text-display ${className}`}
      dangerouslySetInnerHTML={{ __html: purifiedMessage }}
    ></div>
  )
}
